module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [(_vm.project) ? _c('v-form', {
    ref: "createItemForm",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.validForm),
      callback: function($$v) {
        _vm.validForm = $$v
      },
      expression: "validForm"
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "md4": "",
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "v-card"
  }, [_c('div', {
    staticClass: "card-title px-2 py-2"
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v("Name Item & Upload File")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "upload-progress-wrapper"
  }, [(_vm.showProgress) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": _vm.processing
    },
    model: {
      value: (_vm.fileProgress),
      callback: function($$v) {
        _vm.fileProgress = $$v
      },
      expression: "fileProgress"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "px-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Item Name",
      "rules": _vm.requiredRules,
      "autofocus": ""
    },
    model: {
      value: (_vm.project.name),
      callback: function($$v) {
        _vm.$set(_vm.project, "name", $$v)
      },
      expression: "project.name"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "px-2 pb-2 semibold center-align"
  }, [_vm._v("\n              Upload A Single\n              " + _vm._s(_vm.property('width').default) + "″W x\n              " + _vm._s(_vm.property('length').default) + "″H PDF File"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "center-align"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "100%"
    }
  }, [(_vm.hasFiles) ? _c('div', [_c('img', {
    staticClass: "elevation-5 uploaded-file",
    attrs: {
      "src": _vm.project.file.thumbs.medium,
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.preview, true)
      }
    }
  }, [_vm._v("Preview File")])], 1) : _vm._e(), _vm._v(" "), _c('vue-transmit', _vm._b({
    ref: "uploader",
    staticClass: "aspect-ratio-box elevation-2",
    class: _vm.hideIfHasFiles,
    on: {
      "sending": function($event) {
        _vm.showProgress = true
      },
      "upload-progress": _vm.updateProgress,
      "success": _vm.onUploadSuccess,
      "error": _vm.errorUploading,
      "timeout": _vm.onTimeout,
      "drag-start": _vm.onDraging,
      "drag-enter": _vm.onDraging,
      "drag-over": _vm.onDraging,
      "drag-end": _vm.onDroped,
      "drag-leave": _vm.onDroped,
      "drag-drop": _vm.onDroped
    }
  }, 'vue-transmit', _vm.transmitOptions, false), [_c('div', {
    class: _vm.dropable
  }, [_c('br'), _vm._v(" "), _c('v-icon', {
    staticClass: "mt-3 display-3"
  }, [_vm._v("mdi-file-pdf-box")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Drag Your PDF File Here")]), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    or"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    }
  }, [_vm._v("Select a PDF File")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "px-2 py-2"
  }, [_c('p', {
    staticClass: "center-align"
  }, [(_vm.hasFiles) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.triggerBrowse()
      }
    }
  }, [_vm._v("\n                    Select a new PDF File\n                  ")]) : _vm._e(), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "target": "_blank",
      "title": "File Preparation Guidelines",
      "href": "https://www.gungho.com/file-preparation-guidelines/"
    }
  }, [_vm._v("\n                  File Preparation Help\n                ")])], 1)])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "md6 lg6"
  }, [_c('div', {
    staticClass: "v-card"
  }, [_c('div', {
    staticClass: "card-title semibold px-2 py-2"
  }, [_vm._v("\n             Select Options\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "px-2 pt-4"
  }, _vm._l((_vm.project.product.properties), function(property) {
    return _c('div', {
      class: {
        hidden: !property.display
      }
    }, [_c('p', {
      staticClass: "semibold"
    }, [_vm._v(_vm._s(property.title))]), _vm._v(" "), (property.pinned) ? _c('div', {
      staticClass: "pinned-checkbox"
    }, _vm._l((property.options), function(option, index) {
      return _c('v-checkbox', {
        key: option + index,
        attrs: {
          "label": option.label,
          "on-icon": "mdi-check-circle",
          "readonly": "",
          "checked": ""
        },
        model: {
          value: (_vm.pinnedCheckbox),
          callback: function($$v) {
            _vm.pinnedCheckbox = $$v
          },
          expression: "pinnedCheckbox"
        }
      })
    }), 1) : _c('div', [_c('v-radio-group', {
      attrs: {
        "rules": _vm.requiredRules
      },
      model: {
        value: (_vm.project.file[property.name]),
        callback: function($$v) {
          _vm.$set(_vm.project.file, property.name, $$v)
        },
        expression: "project.file[property.name]"
      }
    }, _vm._l((property.options), function(option, index) {
      return _c('v-radio', {
        key: property.name + index,
        attrs: {
          "name": property.name,
          "label": option.label,
          "value": option.value,
          "disabled": option.disabled,
          "validate-on-blur": ""
        }
      })
    }), 1)], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pl-1 pb-2"
  }, [_c('v-btn', {
    attrs: {
      "color": _vm.valid ? 'primary' : 'disabled',
      "depressed": !_vm.valid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem('/items')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": _vm.valid ? 'primary' : 'disabled',
      "depressed": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem()
      }
    }
  }, [_vm._v("Discard")])], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "lg2 hidden-md-and-down"
  }, [_c('div', {
    staticClass: "v-card sticky"
  }, [_c('div', {
    staticClass: "card-title semibold px-2 py-2"
  }, [_vm._v("\n              Item Summary\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "px-2 py-2"
  }, [_c('item-summary', {
    attrs: {
      "item": _vm.project
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.hasFiles) ? _c('div', {
    staticClass: "px-2 py-2"
  }, [(_vm.project.file.files.preview) ? _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.preview, true)
      }
    }
  }, [_vm._v("Preview File")])]) : _vm._e(), _vm._v(" "), (_vm.project.file.files.cover) ? _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.cover, true)
      }
    }
  }, [_vm._v("Cover File")])]) : _vm._e(), _vm._v(" "), (_vm.project.file.files.content) ? _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.content, true)
      }
    }
  }, [_vm._v("Content File")])]) : _vm._e(), _vm._v(" "), (_vm.project.file.files.original) ? _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.original, true)
      }
    }
  }, [_vm._v("Original File")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center-align px-2 py-4"
  }, [_c('fancy-price', {
    attrs: {
      "price": _vm.unitPrice()
    }
  }, [_vm._v(_vm._s(_vm.nextPrice()))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "cart-control center-align"
  }, [_c('v-icon', {
    on: {
      "mousedown": function($event) {
        return _vm.changeQuantity(-1)
      }
    }
  }, [_vm._v("mdi-minus")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantity),
      expression: "quantity"
    }],
    staticClass: "quantity",
    attrs: {
      "name": "quantity",
      "size": "4",
      "maxlength": "3",
      "placeholder": "QTY",
      "mast": "###"
    },
    domProps: {
      "value": (_vm.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-icon', {
    on: {
      "mousedown": function($event) {
        return _vm.changeQuantity(1)
      }
    }
  }, [_vm._v("mdi-plus")])], 1)]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": _vm.valid ? 'primary' : 'disabled',
      "depressed": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.updateCart(_vm.project.id, _vm.quantity)
      }
    }
  }, [_vm._v("Add To Cart")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.hasCartItems,
      "to": "/checkout"
    }
  }, [_vm._v("Check Out")])], 1), _vm._v(" "), _c('br')])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e682e528","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/create/index.vue
// module id = 742
// module chunks = 1